import React, { useEffect, useState } from "react";

import moment from "moment";
import axios from "axios";

import Select, { components } from "react-select";

import AllowLeft from "../../assets/icons/arrowLeft.svg";
import Calendar from "../../assets/icons/biCalendar.svg";
import { ReactComponent as DropdownArrowDown } from "../../assets/icons/dropdownArrowDown.svg";
import { ReactComponent as DropdownArrowUp } from "../../assets/icons/dropdownArrowUp.svg";
import APIVariables from "../../services/api-variables";

//constants
import { registrationCategory } from "../../constants/register.constants";
import { errorMessages } from "../../constants/errorMessages.constants";
import Axios from "../../services/Axios";

import Wholesaler from "../common/Wholesaler/Wholesaler";
import TermsAndConditionsPrescriber from "../common/TermsAndConditions/TermsAndConditionsPrescriber";
import TermsAndConditionsPharmacy from "../common/TermsAndConditions/TermsAndConditionsPharmacy";

import { AsyncPaginate } from "react-select-async-paginate";
import StyledMedication from "./StyledMedication";

const inputStyles =
  "mt-2.5 w-full border-0 border-b border-[#c8c8c8] px-0 py-1 text-lg leading-[22px] text-[#646464] outline-none disabled:cursor-not-allowed";

const errorInputStyles = `${inputStyles} !border-b-[#da291c]`;

const getInputClassName = (hasError) => (hasError ? errorInputStyles : inputStyles);

const labelClass = "text-[#00567a]";
const pageTitleClass = "mt-2.5 pb-1.5 text-[#3c3c3c]";
const sectionTitleClass = "mt-[30px] mb-[25px] text-[#3c3c3c] font-semibold";
const sectionTitleSmClass = "mt-10 text-[#3c3c3c] font-semibold";
const fieldCellClass = "relative mt-4";
const errorTextClass =
  "mt-1 block text-sm font-light italic leading-snug text-[#e41818]";
const errorTextSelectClass =
  "mt-2.5 block text-sm font-light italic leading-snug text-[#e41818]";
const wholesalerErrorClass =
  "col-span-2 mt-2 block text-sm font-light italic leading-snug text-[#e41818]";
const passwordHintClass =
  "mt-1 text-xs font-light leading-[15px] text-[#e41818] [&_p]:m-0 [&_p]:text-xs [&_p]:leading-[15px]";
const passwordHintValidClass =
  "mt-1 text-xs font-light leading-[15px] text-[#00a03b] [&_p]:m-0 [&_p]:text-xs [&_p]:leading-[15px]";
const signSectionClass = "mt-[75px] [&_label]:text-[#00567a]";
const calendarIconClass =
  "pointer-events-none absolute bottom-[21px] right-[50px] z-[-1] w-auto";
const disabledFieldTextClass = "bg-transparent text-[#646464]";

const getSelectWrapperClassName = (hasError) =>
  [
    "mt-2.5",
    hasError ? "[&_.custom-select__control]:!border-b-[#e41818]" : "",
  ]
    .filter(Boolean)
    .join(" ");

const selectionRowClass = "mr-9 flex cursor-pointer items-center gap-3";

const SelectionRow = ({
  checked,
  label,
  inputType = "checkbox",
  name,
  value,
  onChange,
  className = "mt-4",
  dataTestId,
}) => (
  <label className={[selectionRowClass, className].filter(Boolean).join(" ")}>
    <input
      type={inputType}
      name={name}
      value={value}
      checked={checked}
      onChange={onChange}
      className="sr-only"
      data-testid={dataTestId}
    />
    <span
      className={[
        "flex h-5 w-5 shrink-0 items-center justify-center rounded-sm border border-[#00567a]",
        checked ? "bg-[#00567a]" : "bg-white",
      ].join(" ")}
      aria-hidden="true"
    >
      {checked ? (
        <span className="mb-px block h-2.5 w-1.5 rotate-45 border-b-2 border-r-2 border-white" />
      ) : null}
    </span>
    <span className="text-lg leading-[22px] text-[#00567a]">{label}</span>
  </label>
);

const DropdownIndicator = (props) => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        {props.selectProps.menuIsOpen ? (
          <DropdownArrowUp />
        ) : (
          <DropdownArrowDown />
        )}
      </components.DropdownIndicator>
    )
  );
};

const RegisterForm = ({
  stateRegister,
  previous,
  handleChange,
  registerForm,
  isSubmitting,
  formFields,
  handleChangeSelect,
  typeOfForm,
  errorMessage,
  setWasLinkClicked,
  downloadedBrochures,
  setDownloadedBrochures,
  handleChangeWholeSaler,
  setIsLoading,
  products,
  handleCheckboxClick,
  selectedProducts,
  productConfirmations,
  handleCheckboxes,
  checkboxesMedications,
  getListOfBrochures,
  brochureIdAndName,
}) => {
  const [institutionOptions, setInstitutionsOptions] = useState([]);
  const [wholeSalers, setWholeSalers] = useState([]);

  const invalidEmail = (errorMessage || []).find((element) =>
    element.includes("email")
  );
  const invalidRegistrationNumber = (errorMessage || []).find((element) =>
    element.includes("registration_number")
  );
  const invalidPhoneNumber = (errorMessage || []).find((element) =>
    element.includes("phone_number")
  );
  const invalidPassword = (errorMessage || []).find((element) =>
    element.includes("password")
  );
  const invalidWholeSaler = (errorMessage || []).find((element) =>
    element.includes("wholesalers_data")
  );

  const [nextURL, setNextPage] = useState(false);
  const [keyValue, setKeyValue] = useState(0);

  useEffect(() => {
    loadInitial();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // Reset the AsyncPaginate dropdown to start from initial call
    setNextPage(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateRegister]);

  const handleReset = () => {
    setNextPage(false);
    setKeyValue((prevKeyValue) => prevKeyValue + 1);
  };

  useEffect(() => {
    handleReset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [registerForm?.institution_type?.value]);

  const isValidRegistrationFromFE =
    registerForm?.registration_number?.trim().length > 0 &&
    registerForm?.registration_number?.trim().length <= 30 &&
    isSubmitting;

  const isUndefinedRegistratioNumberFE =
    registerForm.registration_number === undefined && isSubmitting;

  const isNotRegistrationNumberTyped =
    isSubmitting &&
    !formFields.registration_number?.isValid &&
    (registerForm.registration_number?.length === 0 ||
      registerForm.registration_number === undefined);

  const isRegistrationNumberExceeded =
    isSubmitting &&
    !formFields.registration_number?.isValid &&
    registerForm?.registration_number?.length >= 30;

  const getBrochure = async (brochure, openInNewPage = false) => {
    const updatedArray = brochureIdAndName.filter(
      (item) => item.brochure_id !== brochure.brochure_id
    );

    updatedArray.length === 0 && setWasLinkClicked(true);
    getListOfBrochures(updatedArray);

    setIsLoading(true);
    await Axios.get(
      APIVariables.PATIENTS_BROCHURES_DOWNLOAD + brochure.brochure_id
    )
      .then((res) => {
        const { data, status } = res;
        if (status === 200) {
          const { brochure_history_id } = data;
          setDownloadedBrochures([...downloadedBrochures, brochure_history_id]);
          return data?.report;
        }
        return null;
      })
      .then(async (brochureString) => {
        const base64 = await fetch(
          `data:application/pdf;base64,${brochureString}`
        );
        return base64.blob();
      })
      .then((blob) => {
        const file = new Blob([blob], {
          type: "application/pdf",
        });
        const fileURL = URL.createObjectURL(file);
        const downloadLink = document.createElement("a");
        downloadLink.href = fileURL;
        if (openInNewPage) {
          downloadLink.target = "_blank";
        } else {
          downloadLink.download = brochure.brochure_name.toString() + ".pdf";
        }
        downloadLink.click();
        downloadLink.remove();
        URL.revokeObjectURL(downloadLink.href);
      })
      .catch(() => { })
      .finally(() => setIsLoading(false));
  };

  const validateRegistrationNumber = () => {
    if (!isValidRegistrationFromFE || isUndefinedRegistratioNumberFE) {
      if (isNotRegistrationNumberTyped) {
        return <span className={errorTextClass}>Required</span>;
      } else if (isRegistrationNumberExceeded) {
        return (
          <span className={errorTextClass}>Registration Number too long</span>
        );
      } else if (invalidRegistrationNumber?.length) {
        return (
          <span className={errorTextClass}>
            {invalidRegistrationNumber?.split("-")[1]}
          </span>
        );
      } else {
        <span className={errorTextClass}></span>;
      }
    } else {
      return <span></span>;
    }
  };

  const renderLabel = (name, postalCode) => (
    <div className="flex items-center justify-between">
      <div>{name}</div>
      <div>{postalCode}</div>
    </div>
  );

  async function loadInitial() {
    if (typeOfForm.includes(registrationCategory.PHARMACY)) {
      const { data: getInstitutionsOptions } = await axios.get(
        process.env.REACT_APP_BASE_URL + APIVariables.HCP_PHARMACY_INSTITUTIONS
      );
      const institutionsOptions = (getInstitutionsOptions || []).map(
        ({ id, value }) => ({
          value: id,
          label: value,
        })
      );

      setInstitutionsOptions(institutionsOptions);

      const { data: getWholesalers } = await axios.get(
        process.env.REACT_APP_BASE_URL + APIVariables.ORDERS_WHOLESALERS
      );
      setWholeSalers(getWholesalers);
    }
  }

  const updateParamsIntoAPI_URL = (search, propertyName) => {
    const fullURL = new URL(nextURL);
    const baseUrl = `${fullURL.origin}${fullURL.pathname}`;

    let urlParams = new URLSearchParams(window.location.search);
    const pageNumber = new URLSearchParams(nextURL.split("?")[1]).get("page");

    urlParams.set(propertyName, search);
    urlParams.set("page", pageNumber);

    let url = `${baseUrl}?${urlParams.toString()}`;
    return url;
  };

  const [uniqueTitles, setUniqueTitles] = useState();

  const uniqueTitlesJoin = uniqueTitles?.join(", ");

  const getTitles = (titles) => {
    // Check if the titles are different before updating state
    if (titles !== uniqueTitles) {
      setUniqueTitles(titles);
    }
  };

  async function loadOptionsPharmacy(search) {
    const selectedInstitutionType = registerForm?.institution_type?.value;

    const baseURLCall =
      process.env.REACT_APP_BASE_URL +
      APIVariables.HCP_PHARMACY_INSTITUTIONS +
      "/" +
      selectedInstitutionType +
      "/list" +
      "?pharmacy_name=" +
      (search || "");

    const apiURL = nextURL
      ? updateParamsIntoAPI_URL(search, "pharmacy_name")
      : baseURLCall;

    const getPharmacyOptions = await axios.get(apiURL).catch(() => {
      setNextPage(false);
    });

    if (getPharmacyOptions.status === 200) {
      const responseJSON = getPharmacyOptions.data;

      const finalData = responseJSON.results.map((element) => {
        return {
          value: element.pharmacy_name + " " + element.postal_code,
          valueForBE: element.id,
          label: renderLabel(element.pharmacy_name, element.postal_code),
          labelToBeDisplayed: element.pharmacy_name,
          address: element.address,
          delivery_address: element.delivery_address,
          ordering_address: element.ordering_address,
          wholesalers_data: element.wholesalers_data,
        };
      });

      let hasMore;
      if (!!responseJSON.next) {
        const url = responseJSON.next;
        const urlParams = new URLSearchParams(url.split("?")[1]);
        const page = urlParams.get("page");
        hasMore = !!page;
      } else {
        hasMore = false;
      }

      if (hasMore) {
        setNextPage(responseJSON.next);
      }

      return {
        options: finalData,
        hasMore: hasMore,
      };
    }
  }

  const loadOptionsHospitals = async (search) => {
    const baseURLCall =
      process.env.REACT_APP_BASE_URL +
      APIVariables.HCP_HOSPITALS +
      "?hospital_name=" +
      (search || "");

    const apiURL = nextURL
      ? updateParamsIntoAPI_URL(search, "hospital_name")
      : baseURLCall;

    const getHospitalOptions = await axios.get(apiURL).catch(() => {
      setNextPage(false);
    });

    if (getHospitalOptions.status === 200) {
      const responseJSON = getHospitalOptions.data;

      const finalData = responseJSON.results.map((element) => {
        return {
          value: element.hospital_name + " " + element.postal_code,
          valueForBE: element.id,
          label: renderLabel(element.hospital_name, element.postal_code),
          address: element.address,
          postal_code: element.postal_code,
        };
      });

      let hasMore;
      if (!!responseJSON.next) {
        const url = responseJSON.next;
        const urlParams = new URLSearchParams(url.split("?")[1]);
        const page = urlParams.get("page");
        hasMore = !!page;
      } else {
        hasMore = false;
      }

      if (hasMore) {
        setNextPage(responseJSON.next);
      }

      return {
        options: finalData,
        hasMore: hasMore,
      };
    }
  };

  // map role keys to numeric values expected by backend
  const PHARMACIST_ROLE_MAP = {
    pharmacist: 0,
    chief_pharmacist: 1,
  };

  const PHARMACIST_TYPE_OPTIONS = [{
    title: "Chief Pharmacist", value: "chief_pharmacist"
  }, { title: "Pharmacist", value: "pharmacist" }]

  const [pharmacist_type, setPharmacistType] = useState(
    registerForm.pharmacist_type || ""
  );

  const handlePharmacistTypeSelect = (roleKey) => {
    const numeric = PHARMACIST_ROLE_MAP[roleKey];
    setPharmacistType(numeric);
    // pass numeric value to parent form state (field name used elsewhere is 'pharmacist_type')
    handleChange({ target: { name: "pharmacist_type", value: numeric } });
  };

  return (
    <React.Fragment>
      {stateRegister === 2 && (
        <React.Fragment>
          <h1 className={pageTitleClass} data-testid="auth-register-form-heading">
            {typeOfForm === registrationCategory.PRESCRIBER_PRESCRIBER
              ? "Prescriber Registration Form"
              : "Pharmacist Registration Form"}
          </h1>

          <hr className="my-0 h-px border-0 bg-[#768692]" />

          <div className="mt-[30px] flex justify-between gap-1.5">
            <button
              type="button"
              className="flex h-[46px] w-[46px] shrink-0 items-center justify-center rounded-full border-0 bg-[#00567a] shadow-[0px_0px_10px_rgba(0,0,0,0.1)] hover:bg-[#005eb8]"
              onClick={previous}
              data-testid="auth-register-form-back-button"
            >
              <img src={AllowLeft} alt="Arrow left" className="m-0 w-5" />
            </button>
            <div className="flex min-w-0 flex-1 items-center justify-center rounded-full bg-[#00567a] px-4 text-base font-bold leading-5 text-[#f8f8f8] shadow-[0px_0px_10px_rgba(0,0,0,0.1)]">
              {typeOfForm === registrationCategory.PRESCRIBER_PRESCRIBER
                ? "Prescriber Registration Form"
                : "Pharmacist Registration Form"}
            </div>
          </div>
          <div data-testid="auth-register-details-section">
            <h2 className={sectionTitleClass} data-testid="auth-register-details-heading">
              {typeOfForm === registrationCategory.PRESCRIBER_PRESCRIBER
                ? "Prescriber Details"
                : "Pharmacist Details"}
            </h2>
            <div className="mb-5">
              <div className="grid gap-4 md:grid-cols-2">
                <div>
                  <label>
                    {typeOfForm === registrationCategory.PRESCRIBER_PRESCRIBER
                      ? "Prescriber First Name*"
                      : "Pharmacist (or appointed deputy) First Name:*"}
                  </label>
                  <input
                    type="text"
                    onChange={handleChange}
                    name="first_name"
                    maxLength={30}
                    value={registerForm.first_name || ""}
                    data-testid="auth-register-first-name-input"
                    className={getInputClassName(isSubmitting && !formFields.first_name.isValid)}
                  />
                  {isSubmitting && !formFields.first_name?.isValid && (
                    <span
                      className={errorTextClass}
                      data-testid="auth-register-first-name-error"
                    >
                      Required
                    </span>
                  )}
                </div>
                <div>
                  <label>
                    {typeOfForm === registrationCategory.PRESCRIBER_PRESCRIBER
                      ? "Prescriber Last Name*"
                      : "Pharmacist (or appointed deputy) Last Name:*"}
                  </label>
                  <input
                    type="text"
                    onChange={handleChange}
                    name="last_name"
                    maxLength={30}
                    value={registerForm.last_name || ""}
                    data-testid="auth-register-last-name-input"
                    className={getInputClassName(isSubmitting && !formFields.last_name.isValid)}
                  />
                  {isSubmitting && !formFields.last_name?.isValid && (
                    <span
                      className={errorTextClass}
                      data-testid="auth-register-last-name-error"
                    >
                      Required
                    </span>
                  )}
                </div>
              </div>
              {typeOfForm.includes(registrationCategory.PRESCRIBER) && (
                <div className="grid gap-4 md:grid-cols-2">
                  <div className="mt-4">
                    <label>Registration Number:*</label>
                    <input
                      type="text"
                      onChange={handleChange}
                      name="registration_number"
                      maxLength={30}
                      value={registerForm.registration_number || ""}
                      data-testid="auth-register-registration-number-input"
                      className={getInputClassName(isSubmitting && !formFields.registration_number.isValid)}
                    />
                    <React.Fragment>
                      {validateRegistrationNumber()}
                    </React.Fragment>
                  </div>
                  <div className="mt-4">
                    <label>Job Title:*</label>
                    <input
                      type="text"
                      onChange={handleChange}
                      name="job_title"
                      maxLength={30}
                      value={registerForm.job_title || ""}
                      data-testid="auth-register-job-title-input"
                      className={getInputClassName(isSubmitting && !formFields.job_title.isValid)}
                    />
                    {isSubmitting && !formFields.job_title?.isValid && (
                      <span
                        className={errorTextClass}
                        data-testid="auth-register-job-title-error"
                      >
                        Required
                      </span>
                    )}
                  </div>
                </div>
              )}
              {typeOfForm === registrationCategory.PHARMACY && (
                <div className="grid gap-4 md:grid-cols-2">
                  <div className="mt-4">
                    <label>GPhC / PSNI Registration Number:*</label>
                    <input
                      type="text"
                      onChange={handleChange}
                      name="registration_number"
                      maxLength={30}
                      value={registerForm.registration_number || ""}
                      data-testid="auth-register-registration-number-input"
                      className={getInputClassName(isSubmitting && !formFields.registration_number.isValid)}
                    />
                    <React.Fragment>
                      {validateRegistrationNumber()}
                    </React.Fragment>
                  </div>
                  <div
                    className={fieldCellClass}
                    data-testid="auth-register-institution-type-select"
                  >
                    <label className={labelClass}>Institution type:*</label>
                    <Select
                      classNamePrefix="custom-select"
                      components={{
                        DropdownIndicator: DropdownIndicator,
                        IndicatorSeparator: () => null,
                      }}
                      value={registerForm.institution_type}
                      onChange={(selectedOption) => {
                        handleChangeSelect(selectedOption, "institution_type");
                      }}
                      options={institutionOptions}
                      placeholder="Select"
                      className={getSelectWrapperClassName(
                        isSubmitting && !formFields.institution_type.isValid
                      )}
                    />
                    {isSubmitting && !formFields.institution_type?.isValid && (
                      <span className={errorTextSelectClass}>Required</span>
                    )}
                  </div>
                </div>
              )}
              <div className="grid gap-4 md:grid-cols-2">
                {typeOfForm === registrationCategory.PHARMACY && (
                  <React.Fragment>
                    <div className="mt-4">
                      <label>Phone Number:*</label>
                      <input
                        onChange={handleChange}
                        name="phone_number"
                        value={registerForm.phone_number || ""}
                        maxLength="21" // Max Length for Phone Number is 20 Length but because we have a space in the format phone it is also considered part of the number
                        type="text"
                        data-testid="auth-register-phone-input"
                        className={getInputClassName(isSubmitting && !formFields.phone_number.isValid)}
                      />

                      {isSubmitting && !formFields.phone_number?.isValid ? (
                        <span
                          className={errorTextClass}
                          data-testid="auth-register-phone-error"
                        >
                          Required
                        </span>
                      ) : invalidPhoneNumber ? (
                        <span
                          className={errorTextClass}
                          data-testid="auth-register-phone-error"
                        >
                          {invalidPhoneNumber.split(",")[0]}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                    <div
                      className={fieldCellClass}
                      data-testid="auth-register-institution-name-select"
                    >
                      <label className={labelClass}>Institution Name:*</label>
                      <AsyncPaginate
                        key={keyValue} // Use a unique key to reset the loadOptions function
                        debounceTimeout={300}
                        loadOptions={loadOptionsPharmacy}
                        classNamePrefix="custom-select"
                        onChange={(selectedOption) => {
                          handleChangeSelect(selectedOption, "institution_id");
                        }}
                        className={getSelectWrapperClassName(
                          isSubmitting && !formFields.institution_id.isValid
                        )}
                        value={registerForm.institution_id}
                        isDisabled={!registerForm.institution_type}
                      />
                      {isSubmitting && !formFields.institution_id?.isValid && (
                        <span className={errorTextSelectClass}>Required</span>
                      )}
                    </div>
                  </React.Fragment>
                )}
                {typeOfForm.includes(registrationCategory.PRESCRIBER) && (
                  <div
                    className={fieldCellClass}
                    data-testid="auth-register-hospital-name-select"
                  >
                    <label className={labelClass}>Hospital Name:*</label>
                    <AsyncPaginate
                      debounceTimeout={300}
                      loadOptions={loadOptionsHospitals}
                      classNamePrefix="custom-select"
                      onChange={(selectedOption) => {
                        handleChangeSelect(selectedOption, "hospital_id");
                      }}
                      className={getSelectWrapperClassName(
                        isSubmitting && !formFields.hospital_id.isValid
                      )}
                      value={registerForm.hospital_id}
                    />
                    {isSubmitting && !formFields.hospital_id?.isValid && (
                      <span className={errorTextSelectClass}>Required</span>
                    )}
                  </div>
                )}
              </div>
              <div className="grid gap-4 md:grid-cols-2">
                {typeOfForm === registrationCategory.PHARMACY && (
                  <React.Fragment>
                    <div className="mt-4" data-testid="auth-register-pharmacist-type-section">
                      <label>Please select the role that matches your level of responsibility*</label>
                      <StyledMedication role="radiogroup" aria-labelledby="pharmacist-type">
                        {PHARMACIST_TYPE_OPTIONS.map((pharmacistType) => {
                          const checked =
                            pharmacist_type ===
                            PHARMACIST_ROLE_MAP[pharmacistType.value];
                          return (
                            <SelectionRow
                              key={pharmacistType.value}
                              className="mt-3"
                              inputType="radio"
                              name="pharmacy_type"
                              value={pharmacistType.value}
                              checked={checked}
                              onChange={() =>
                                handlePharmacistTypeSelect(pharmacistType.value)
                              }
                              label={pharmacistType.title}
                              dataTestId={`auth-register-pharmacist-type-${pharmacistType.value}`}
                            />
                          );
                        })}
                      </StyledMedication>
                      {isSubmitting && !formFields.pharmacist_type?.isValid && (
                        <div className="mb-3">
                          <span className="text-sm font-light italic text-[#e41818]">
                            At least one Pharmacy Type is required
                          </span>
                        </div>
                      )}
                    </div>
                    <div className={fieldCellClass}>
                      <div>
                        <span className="font-bold">
                          Note:
                        </span> If the institution you require does not appear in the drop down menu, please contact <span className="underline">support@pharmacaregroup.co.uk</span>
                      </div>
                    </div>
                  </React.Fragment>
                )}
              </div>
              {typeOfForm !== registrationCategory.PHARMACY && (
                <div className="grid gap-4 md:grid-cols-2">
                  <div className="md:col-span-2 mt-4">
                    <label>Hospital Address:</label>
                    <input
                      type="text"
                      name="hospital_address"
                      value={registerForm?.hospital_id?.address || ""}
                      disabled
                      data-testid="auth-register-hospital-address-input"
                      className={inputStyles}
                    />
                  </div>
                </div>
              )}
              {typeOfForm === registrationCategory.PHARMACY && (
                <div className="grid gap-4 md:grid-cols-2">
                  <div className="md:col-span-2 mt-4">
                    <label>Dispensing Pharmacy Address:*</label>
                    <input
                      type="text"
                      name="address1"
                      value={registerForm?.institution_id?.address || ""}
                      disabled
                      data-testid="auth-register-pharmacy-address-input"
                      className={inputStyles}
                    />
                  </div>
                </div>
              )}
              {typeOfForm === registrationCategory.PHARMACY && (
                <div className="grid gap-4 md:grid-cols-2">
                  <div className="md:col-span-2 mt-4">
                    <label>Delivery Address (if different):</label>
                    <input
                      type="text"
                      name="delivery_address"
                      value={registerForm.delivery_address || ""}
                      maxLength="75"
                      onChange={handleChange}
                      placeholder="Only complete if different to the address listed above"
                      data-testid="auth-register-delivery-address-input"
                      className={inputStyles}
                    />
                  </div>
                </div>
              )}
              {typeOfForm === registrationCategory.PHARMACY && (
                <div className="grid gap-4 md:grid-cols-2">
                  <div className="md:col-span-2 mt-4">
                    <label>
                      Ordering Address (If different to delivery address):
                    </label>
                    <input
                      type="text"
                      name="ordering_address"
                      value={registerForm.ordering_address || ""}
                      maxLength="75"
                      onChange={handleChange}
                      placeholder="Only complete if different to the address listed above"
                      data-testid="auth-register-ordering-address-input"
                      className={inputStyles}
                    />
                  </div>
                </div>
              )}
            </div>

            {typeOfForm === registrationCategory.PHARMACY ? (
              <React.Fragment>
                <h2
                  className={sectionTitleSmClass}
                  data-testid="auth-register-wholesaler-heading"
                >
                  Wholesaler Details
                </h2>
                <div
                  className="relative mb-3 grid gap-4 md:grid-cols-2"
                  style={{ position: "relative" }}
                  data-testid="auth-register-wholesaler-section"
                >
                  {(wholeSalers || []).map((wholesaler) => (
                    <div key={wholesaler.id}>
                      <Wholesaler
                        registerForm={registerForm}
                        wholesaler={wholesaler}
                        handleChangeWholeSaler={handleChangeWholeSaler}
                        formFields={formFields}
                        isSubmitting={isSubmitting}
                        isEditMode={registerForm?.institution_id}
                      />
                    </div>
                  ))}
                  {isSubmitting && !formFields.wholesalers_data?.isValid ? (
                    <span
                      className={wholesalerErrorClass}
                      data-testid="auth-register-wholesaler-error"
                    >
                      At least one Wholesaler Detail is required
                    </span>
                  ) : invalidWholeSaler?.length ? (
                    <span
                      className={wholesalerErrorClass}
                      data-testid="auth-register-wholesaler-error"
                    >
                      {invalidWholeSaler?.split("-")[1]}
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </React.Fragment>
            ) : (
              ""
            )}

            <h2
              className={sectionTitleSmClass}
              data-testid="auth-register-medication-heading"
            >
              {" "}
              Medication*:
            </h2>
            <p>Please select the medication in which you want to prescribe.</p>

            <StyledMedication data-testid="auth-register-medication-section">
              {products?.map((medication) => (
                <SelectionRow
                  key={medication.product_id}
                  checked={selectedProducts.includes(medication.product_id)}
                  onChange={() => handleCheckboxClick(medication.product_id)}
                  label={medication.name}
                  dataTestId={`auth-register-medication-checkbox-${medication.product_id}`}
                />
              ))}
            </StyledMedication>
            <div>
              <p className="mt-4">
                IMPORTANT: You will only be able to receive PAFs for molecules
                in which you have checked and registered with.
              </p>
              {isSubmitting && !formFields.products?.isValid && (
                <span
                  className="text-sm font-light italic text-[#e41818]"
                  data-testid="auth-register-medication-error"
                >
                  At least one Medication is required
                </span>
              )}
            </div>

            <h2
              className={sectionTitleSmClass}
              data-testid="auth-register-account-heading"
            >
              Account Details
            </h2>

            <div className="mb-5" data-testid="auth-register-account-section">
              <div className="grid gap-4 md:grid-cols-2">
                <div className={`md:col-span-2 ${fieldCellClass}`}>
                  <label>
                    Email Address: (A link will be sent to verify your email
                    address)*
                  </label>
                  <input
                    type="text"
                    onChange={handleChange}
                    name="email"
                    maxLength={50}
                    value={registerForm.email || ""}
                    data-testid="auth-register-email-input"
                    className={getInputClassName(
                      (isSubmitting && !formFields.email.isValid) ||
                      (isSubmitting &&
                        !formFields.emailValid.isValid &&
                        formFields.email.isValid)
                    )}
                  />
                  {isSubmitting && !formFields.email.isValid && (
                    <span
                      className={errorTextClass}
                      data-testid="auth-register-email-error"
                    >
                      Required
                    </span>
                  )}
                  {isSubmitting &&
                    !formFields.emailValid.isValid &&
                    formFields.email.isValid && (
                      <span
                        className={errorTextClass}
                        data-testid="auth-register-email-error"
                      >
                        Invalid Email
                      </span>
                    )}
                  {invalidEmail?.length && (
                    <span
                      className={errorTextClass}
                      data-testid="auth-register-email-error"
                    >
                      {invalidEmail?.split("-")[1]}
                    </span>
                  )}
                </div>
              </div>
              <div className="grid gap-4 md:grid-cols-2">
                <div className={fieldCellClass}>
                  <label>Create Password:*</label>
                  <input
                    type="password"
                    onChange={handleChange}
                    name="password1"
                    maxLength={64}
                    value={registerForm.password1 || ""}
                    data-testid="auth-register-password-input"
                    className={getInputClassName(isSubmitting && !formFields.password1.isValid)}
                  />
                  {isSubmitting && !formFields.password1?.isValid ? (
                    <div
                      className={passwordHintClass}
                      data-testid="auth-register-password-error"
                    >
                      <p>Minimum length of 12 characters</p>
                      <p> Minimum of 1 uppercase letter.</p>
                      <p> At least 1 non-alphanumeric character (~!@#$%)</p>
                      <p>At least 1 number</p>
                    </div>
                  ) : isSubmitting && !formFields.passwordMatch?.isValid ? (
                    <span
                      className={errorTextClass}
                      data-testid="auth-register-password-error"
                    >
                      {errorMessages.PASSWORD_NOT_MATCH}
                    </span>
                  ) : invalidPassword?.length ? (
                    <span
                      className={errorTextClass}
                      data-testid="auth-register-password-error"
                    >
                      {invalidPassword.split("-")[1]}
                    </span>
                  ) : isSubmitting &&
                    formFields.password1?.isValid &&
                    formFields.password2?.isValid ? (
                    <div className={passwordHintValidClass}>
                      <p>Minimum length of 12 characters</p>
                      <p> Minimum of 1 uppercase letter.</p>
                      <p> At least 1 non-alphanumeric character (~!@#$%)</p>
                      <p>At least 1 number</p>
                    </div>
                  ) : (
                    <span></span>
                  )}
                </div>
                <div className="mt-4">
                  <label>Confirm Password:*</label>
                  <input
                    type="password"
                    onChange={handleChange}
                    name="password2"
                    maxLength={64}
                    value={registerForm.password2 || ""}
                    data-testid="auth-register-confirm-password-input"
                    className={getInputClassName(isSubmitting && !formFields.password2.isValid)}
                  />
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      )}

      <React.Fragment>
        {stateRegister === 3 && (
          <React.Fragment>
            <h1
              className={pageTitleClass}
              data-testid="auth-register-confirmation-heading"
            >
              {typeOfForm === registrationCategory.PRESCRIBER_PRESCRIBER
                ? "Prescriber Registration Form"
                : "Pharmacist Registration Form"}
            </h1>

            <hr className="my-0 h-px border-0 bg-[#768692]" />

            {typeOfForm.includes(registrationCategory.PRESCRIBER) && (
              <h2
                className={`${sectionTitleClass} text-[#00567a]`}
                data-testid="auth-register-prescriber-confirmation-heading"
              >
                Prescriber Confirmation
              </h2>
            )}

            {typeOfForm === registrationCategory.PHARMACY && (
              <div data-testid="auth-register-pharmacy-terms">
                <TermsAndConditionsPharmacy
                  getTitles={getTitles}
                  uniqueTitlesJoin={uniqueTitlesJoin}
                  products={products}
                  getBrochure={getBrochure}
                  handleCheckboxClick={handleCheckboxClick}
                  handleCheckboxes={handleCheckboxes}
                  selectedProducts={selectedProducts}
                  productConfirmations={productConfirmations}
                  checkboxesMedications={checkboxesMedications}
                  institutionName={registerForm.institution_id.labelToBeDisplayed}
                  userType={typeOfForm}
                />
              </div>
            )}

            {typeOfForm.includes(registrationCategory.PRESCRIBER) && (
              <div data-testid="auth-register-prescriber-terms">
                <TermsAndConditionsPrescriber
                  products={products}
                  selectedProducts={selectedProducts}
                  getBrochure={getBrochure}
                  productConfirmations={productConfirmations}
                  handleCheckboxClick={handleCheckboxClick}
                  handleCheckboxes={handleCheckboxes}
                  checkboxesMedications={checkboxesMedications}
                />
              </div>
            )}

            <div
              className={signSectionClass}
              data-testid="auth-register-sign-section"
            >
              <div className="grid gap-4 md:grid-cols-2">
                <div>
                  <label>
                    {typeOfForm === registrationCategory.PRESCRIBER_PRESCRIBER
                      ? "Prescriber Name"
                      : "Pharmacist Name"}
                  </label>
                  <input
                    type="text"
                    className={`${inputStyles} ${disabledFieldTextClass}`}
                    name="pharmacistName"
                    value={
                      registerForm.first_name + " " + registerForm.last_name
                    }
                    disabled
                    data-testid="auth-register-sign-name-input"
                  />
                </div>
                <div>
                  <label>Date:</label>
                  <input
                    className={`${inputStyles} ${disabledFieldTextClass}`}
                    value={moment().format("DD / MM / YYYY")}
                    disabled
                    data-testid="auth-register-sign-date-input"
                  />
                  <img src={Calendar} alt="Calendar" className={calendarIconClass} />
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </React.Fragment>
    </React.Fragment >
  );
};
export default RegisterForm;
